module.exports = __webpack_public_path__ + "img/h-page4-52.72b6878d.png";